require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-give-the-gift-of-education.json") })
        }
      }, "path---blog-give-the-gift-of-education");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-give-the-gift-of-education!./.cache/json/blog-give-the-gift-of-education.json
// module id = 841
// module chunks = 231608221292675